import { useList } from "src/system/useList.tsx";
import type { PriceListResource, ProductResource } from "@exonn/js-sdk";
import { ResourceEnum } from "src/constants/constants.ts";
import { useResourceFormData } from "src/components/Form/hooks/useResourceFormData.ts";
import { SetPriceListRow } from "src/components/Form/panels/PricePanel/components/SetPriceListRow/SetPriceListRow.tsx";

export const SetPriceListItemsEdit = () => {
  const { data: priceListData } = useList<PriceListResource>({
    resource: ResourceEnum.PriceList,
    include: ["currency"],
    queryOptions: {
      refetchOnMount: true,
    },
  });
  const data = useResourceFormData<{
    data: ProductResource;
  }>();
  const priceLists = priceListData?.data || [];
  const variant = data?.data.variants?.[0];

  const assignedPriceLists = priceLists.filter((priceList) => {
    if (priceList.calculate_type !== null) {
      return true;
    }
    return variant?.components!.some((component) => {
      return component.priceListItems!.some(
        (item) => item.priceList!.id === priceList.id,
      );
    });
  });

  return (
    <>
      {variant && !!priceLists?.length && !!assignedPriceLists.length && (
        <div>
          {assignedPriceLists.map(({ id }) => {
            return <SetPriceListRow variant={variant} key={id} id={id} />;
          })}
        </div>
      )}
    </>
  );
};
